module.exports = __webpack_public_path__ + "components/flag/static/square/ir-9058c84b7a3c9d148db0486fce7d3293.svg";